export default __webpack_public_path__ + "static/media/53t.5e632ef2.jpg";